import { render, staticRenderFns } from "./my_form.vue?vue&type=template&id=4327a68b&scoped=true"
import script from "./my_form.vue?vue&type=script&lang=js"
export * from "./my_form.vue?vue&type=script&lang=js"
import style0 from "./my_form.vue?vue&type=style&index=0&id=4327a68b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4327a68b",
  null
  
)

export default component.exports